// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__udDji","header":"PatientQuestionnaire_header__SuWYr","info":"PatientQuestionnaire_info__2K8Kb"};